


import {SystemDataVM} from './SystemDataVM';
export class ReasonForMedicationVM extends SystemDataVM {
    
}
